module.exports = __webpack_public_path__ + "img/product-info-mobile.17e3f5a8.png";